import React, { useState } from 'react';
import { ApiTest } from '../components/common/ApiTest';
import { LocalDevSetup } from '../components/common/LocalDevSetup';
import { IPDetector } from '../components/common/IPDetector';
import { Button } from '../components/common/Button';
import { Activity, Settings, Globe } from 'lucide-react';

interface ApiTestPageProps {
  onNavigate?: (page: string) => void;
}

export const ApiTestPage: React.FC<ApiTestPageProps> = () => {
  const [activeTab, setActiveTab] = useState<'status' | 'setup' | 'ip'>('ip');

  return (
    <div className="max-w-4xl mx-auto">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-navy-900 mb-2">System Status</h2>
        <p className="text-navy-600">
          Monitor API connectivity, detect IP addresses, and configure development environment.
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="mb-6 flex items-center space-x-4">
        <Button
          variant={activeTab === 'ip' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('ip')}
          icon={Globe}
          size="sm"
        >
          IP Detection
        </Button>
        <Button
          variant={activeTab === 'status' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('status')}
          icon={Activity}
          size="sm"
        >
          API Status
        </Button>
        <Button
          variant={activeTab === 'setup' ? 'primary' : 'outline'}
          onClick={() => setActiveTab('setup')}
          icon={Settings}
          size="sm"
        >
          Setup Guide
        </Button>
      </div>
      
      {/* Tab Content */}
      {activeTab === 'ip' && <IPDetector />}
      {activeTab === 'status' && <ApiTest />}
      {activeTab === 'setup' && <LocalDevSetup />}
    </div>
  );
};